/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyEngine_Models_Platform {
    WEB = 'Web',
    IVR = 'IVR',
}
